/**
 * Created by alvinoktavianus on 8/11/17.
 */

import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import styles from './InformationModal.css'

class InformationModal extends Component {
  render () {
    let {onShow, click} = this.props
    return <div>
      <Modal show={onShow} dialogClassName={`${styles['dialog']} ${styles['info-modal-wrapper']} modal-dialog`} onHide={click}>
        <Modal.Body>
          <div>
            <h3 className={`text-center ${styles['no-mtop']}`}>Information</h3>
            <p className='text-center'>COGS adjustment happens when you create a Purchase Order, Refund or have an Incoming Transfer for an item that previously had negative inventory.</p>
            <a onClick={click} className={`btn btn-default btn-block btn-sm ${styles['blue-button']}`}><strong>OK</strong></a>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  }
}

export default InformationModal



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/GrossProfit/InformationModal/InformationModal.js